<script setup lang="ts">
import { inject, ref, type Ref } from 'vue'
import { useRouter } from 'vue-router'
import { SuiForm } from 'vue-fomantic-ui'
import Title from '@/components/Title.vue'
import ContainerHeading from '@/components/Heading/ContainerHeading.vue'

const router = useRouter()
const sync = inject('sync') as Function

const weight: Ref<number | null> = ref(null)
const incorrectWeight = ref(false)
const saving = ref(false)

const save = async () => {
  saving.value = true

  if (weight.value !== null && !isNaN(weight.value) && weight.value <= import.meta.env.VITE_CONTAINER_MAX_WEIGHT) {
    await sync(weight.value)
    router.push({ name: 'weigh-container-scan' })
  } else {
    incorrectWeight.value = true
    saving.value = false
  }
}
</script>

<template>
  <div class="page weigh-container-manual">
    <Title>Peser un bac</Title>
    <ContainerHeading></ContainerHeading>
    <img src="../assets/zebra-container-scanned.svg" alt="Bac" />
    <SuiForm>
      <div :class="{ field: true, error: incorrectWeight }">
        <div class="ui right labeled input">
          <input type="number" step="any" autofocus v-model="weight" />
          <div class="ui basic label">kg</div>
        </div>
      </div>
      <SuiButton class="submit" :loading="saving" @click.prevent="save">Valider</SuiButton>
    </SuiForm>
  </div>
</template>

<style scoped lang="scss">
.weigh-container-manual {
  img {
    display: block;
    max-height: 20dvh;
    margin: 5vh auto;
  }

  .submit {
    margin-top: 3dvh;
  }
}

/* @TODO: override Fomantic styles in a cleaner way */
.ui.form {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2dvh 0;
}
.ui.form input:not([type]),
.ui.form input[type='color'],
.ui.form input[type='date'],
.ui.form input[type='datetime-local'],
.ui.form input[type='email'],
.ui.form input[type='month'],
.ui.form input[type='number'],
.ui.form input[type='password'],
.ui.form input[type='search'],
.ui.form input[type='tel'],
.ui.form input[type='time'],
.ui.form input[type='text'],
.ui.form input[type='file'],
.ui.form input[type='url'],
.ui.form input[type='week'] {
  font-family: 'Libre Franklin', sans-serif;
  margin: 0;
  outline: none;
  -webkit-appearance: none;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  line-height: 1.21428571em;
  padding: 7px 10px 6px 10px;
  font-size: 1em;
  background: #fff;
  border: 1px solid #e0e2ed;
  color: #344c60;
  border-radius: 2px;
  box-shadow: 0 0 0 0 transparent inset;
  transition:
    color 0.1s ease,
    border-color 0.1s ease;
}
.ui.form .fields.error .field textarea,
.ui.form .fields.error .field select,
.ui.form .fields.error .field input:not([type]),
.ui.form .fields.error .field input[type='color'],
.ui.form .fields.error .field input[type='date'],
.ui.form .fields.error .field input[type='datetime-local'],
.ui.form .fields.error .field input[type='email'],
.ui.form .fields.error .field input[type='month'],
.ui.form .fields.error .field input[type='number'],
.ui.form .fields.error .field input[type='password'],
.ui.form .fields.error .field input[type='search'],
.ui.form .fields.error .field input[type='tel'],
.ui.form .fields.error .field input[type='time'],
.ui.form .fields.error .field input[type='text'],
.ui.form .fields.error .field input[type='file'],
.ui.form .fields.error .field input[type='url'],
.ui.form .fields.error .field input[type='week'],
.ui.form .field.error textarea,
.ui.form .field.error select,
.ui.form .field.error input:not([type]),
.ui.form .field.error input[type='color'],
.ui.form .field.error input[type='date'],
.ui.form .field.error input[type='datetime-local'],
.ui.form .field.error input[type='email'],
.ui.form .field.error input[type='month'],
.ui.form .field.error input[type='number'],
.ui.form .field.error input[type='password'],
.ui.form .field.error input[type='search'],
.ui.form .field.error input[type='tel'],
.ui.form .field.error input[type='time'],
.ui.form .field.error input[type='text'],
.ui.form .field.error input[type='file'],
.ui.form .field.error input[type='url'],
.ui.form .field.error input[type='week'] {
  color: #9f3a38;
  background: #fff6f6;
  border-color: #e0b4b4;
  border-radius: '';
  box-shadow: none;
}
.ui.form .ui.labeled.input {
  border: 1px solid #344c60;
  border-radius: 10px;
  font-size: 20px;
}
.ui.form .ui.labeled.input > input {
  border: none;
  border-radius: 10px;
  padding-left: 12px;
  width: 35vw;
}
.ui.form .ui.labeled.input > .ui.label {
  border: none;
  border-radius: 10px;
  font-weight: normal;
  padding-top: 10px;
  padding-bottom: 10px;
}
.ui.basic.labels .label,
.ui.basic.label {
  background: none #fff;
  border: 1px solid rgba(34, 36, 38, 0.15);
  color: #344c60;
  box-shadow: none;
  padding-top: calc(0.5833em - 1px);
  padding-bottom: calc(0.5833em - 1px);
  padding-right: calc(0.833em - 1px);
}
.ui.button {
  padding: 8px 20px 7px 20px;
  background-color: #344c60;
  transition: opacity 0.25s;
  color: white;
  border-radius: 10px;
  font-weight: 600;
  text-transform: uppercase;
  margin: 0;
  height: 40px;
  width: 60%;
  line-height: 22px;
}
</style>
